module.exports = __webpack_public_path__ + "img/还原.a170029b.svg";